document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector(".text-atletes-btn a");
    const textContainer = document.querySelector(".text-atletes");

    btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (textContainer.style.maxHeight) {
            textContainer.style.maxHeight = "";
            btn.textContent = "LER MAIS";
        } else {
            textContainer.style.maxHeight = "none";
            btn.textContent = "LER MENOS";
        }
    });
});
